import React from 'react';
import Helmet from 'react-helmet';

import { IAppData } from 'client/common/types';
import { replaceHtmlEntities } from 'utils/helper';

interface IMetaSeoProps extends Pick<IAppData, 'seo'>{}

function MetaSeo({ seo }: IMetaSeoProps) {
    return (
        <Helmet>
            <title>{seo && replaceHtmlEntities(seo.title)}</title>
            <meta name="description" content={seo && seo.description} />
            <meta name="keywords" content={seo && seo.keywords} />
        </Helmet>
    );
}

export default MetaSeo;
